import { fetchParentsDocumentPart } from "../../api/document/DocumentsPart";
import { deleteDocumentPartAsync } from "../../redux/feature/document/document-slice";
import { TreeViewDataItem } from "../../components/cpm/DocumentPartTree";
import {
  DocumentPropertiesActionTypes,
  DocumentPropertiesMessagesModal,
} from "../../components/cpm/DocumentPropertiesMessagesModal";
import React, { useEffect, useState } from "react";
import { DocumentPart } from "../../api/models";

export const DeleteDocumentHelper = (props: {
  deleteItem?: DocumentPart;
  onCancelDelete: () => void;
  partRoot: DocumentPart;
  currentDocumentPartId?: string;
}) => {
  const [state, setState] = useState<{
    action: DocumentPropertiesActionTypes;
    deleteItem: DocumentPart;
    selectedItemFathers?: TreeViewDataItem[];
  }>({ deleteItem: props.deleteItem, action: null });

  const hidePanel = () => {
    setState({ deleteItem: null, action: null });
    props.onCancelDelete();
  };

  useEffect(() => {
    if (!props.deleteItem) return;
    if (props.deleteItem.root) {
      //library -> delete a root
      setState({ deleteItem: props.deleteItem, action: "confirm" });
    } else {
      checkFathers(props.deleteItem);
    }
  }, [props.deleteItem]);

  const checkFathers = async (selectedPart: DocumentPart) => {
    let fathers: TreeViewDataItem[] = await fetchFathers(selectedPart.id);
    if (fathers.length > 1) {
      setState({
        deleteItem: selectedPart,
        action: "confirmNumberOfFathers",
        selectedItemFathers: fathers,
      });
    } else {
      await checkHasChildren(selectedPart);
    }
  };

  const fetchFathers = async (documentPartId: string): Promise<TreeViewDataItem[]> => {
    const documentParts = await fetchParentsDocumentPart(documentPartId);
    return documentParts.map((documentPart) => ({
      key: documentPart.id,
      text: documentPart.name,
      nodeType: "root",
      hasChildren: documentPart.hasChildren,
      expanded: false,
      checked: false,
      selected: false,
      items: null,
      data: documentPart,
    }));
  };

  const onDeleteConfirm = async (selectedPart: DocumentPart) => {
    await checkHasChildren(selectedPart);
  };

  const checkHasChildren = async (selectedPart: DocumentPart) => {
    if (selectedPart.hasChildren) {
      hidePanel();
      setState({
        deleteItem: selectedPart,
        action: "confirmChildrenDeletion",
      });
    } else if (!selectedPart.root) {
      hidePanel();
      setState({ deleteItem: selectedPart, action: "confirm" });
    }
  };

  const deleteDocumentPart = async () => {
    const isRoot = state.deleteItem.id === props.partRoot.id;
    const isDeleteFromClient = props.currentDocumentPartId === props.partRoot.id;

    await deleteDocumentPartAsync({
      docPartId: state.deleteItem.id,
      docPartDriveItemId: state.deleteItem.driveItemId,
      openedFatherDocumentPartId: props.partRoot?.id,
      isRoot: isRoot,
      deleteFromClient: isDeleteFromClient,
    });

    hidePanel();
  };

  return (
    <DocumentPropertiesMessagesModal
      isModalOpen={Boolean(state.action && state.deleteItem)}
      onHideModal={() => {
        hidePanel();
      }}
      deleteItem={state.deleteItem}
      action={state.action}
      selectedItemFathers={state.selectedItemFathers}
      onDeleteConfirm={onDeleteConfirm}
      deleteDocumentPart={deleteDocumentPart}
    />
  );
};
